import Ajax from '@/lib/ajax'

export default {
  getList(MaxResultCount: number, currentPage: number, sorting?: string) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount
    }
    return Ajax.get(`/api/distribution/distributionDistributor`, {
      params: params
    })
  },
  create(data: any) {
    return Ajax.post(`/api/distribution/distributionDistributor`, data)
  },
  createBatch(data: any[]) {
    return Ajax.post(`/api/distribution/distributionDistributor/batch`, data)
  },
  update(id: string, data: any) {
    return Ajax.put(`/api/distribution/distributionDistributor/${id}`, data)
  },
  deleteItem(ids: string[]) {
    return Ajax.delete(`/api/distribution/distributionDistributor`, {
      params: { ids }
    })
  }
}
